import { FormBase } from "core/components";

export default class AdditionalValidationForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "silverDressingValidations",
                },
            ],
        };
    }
}
